<template>
	<SectionCard title="Scrittura automatica con l'IA" icon="mdi-robot-outline" :subtitle="blog.active ? 'attiva' : 'spenta'">
		<template v-slot:actions>
			<v-switch v-model="blog.active" data-tour="switch" color="primary" hide-details class="mt-0 pt-0" @change="$emit('salva')" />
		</template>

		<div class="bs-summary">
			<div class="bs-fact">
				<v-icon small color="primary" class="mr-1">mdi-calendar-month-outline</v-icon><strong>{{ blog.setting.times || 0 }}</strong
				>&nbsp;articoli al mese
			</div>
			<div class="bs-fact">
				<v-icon small color="primary" class="mr-1">mdi-translate</v-icon>condivisi in <strong>&nbsp;{{ (blog.setting.lang || '—').toUpperCase() }}</strong>
			</div>
			<div class="bs-fact"><v-icon small color="primary" class="mr-1">mdi-share-variant-outline</v-icon>{{ (blog.setting.share || []).length ? blog.setting.share.join(', ') : 'nessun social' }}</div>
			<v-spacer></v-spacer>
			<v-btn small text color="primary" data-tour="expand" @click="$emit('apri')">
				<v-icon left small>{{ aperto ? 'mdi-minus' : 'mdi-tune-variant' }}</v-icon
				>{{ aperto ? 'Chiudi impostazioni' : 'Regole e impostazioni' }}
			</v-btn>
		</div>

		<div v-if="aperto" class="bs-body" data-tour="settings">
			<v-row class="bs-fields">
				<v-col cols="12" sm="4">
					<v-text-field v-model="blog.setting.times" label="Articoli ogni mese" type="number" min="0" prepend-inner-icon="mdi-calendar-month-outline" outlined dense hide-details />
				</v-col>
				<v-col cols="12" sm="4">
					<v-select
						v-model="blog.setting.lang"
						:items="langs"
						item-value="lang"
						:item-text="l => String(l.lang).toUpperCase()"
						label="Lingua di condivisione"
						prepend-inner-icon="mdi-translate"
						outlined
						dense
						hide-details
					/>
				</v-col>
				<v-col cols="12" sm="4">
					<div class="bs-label">Dove condividere</div>
					<div class="bs-socials">
						<button v-for="s in social" :key="s.value" type="button" class="bs-social" :class="{ 'bs-social--on': condiviso(s.value) }" @click="cambiaSocial(s.value)">
							<v-icon small :color="condiviso(s.value) ? 'primary' : 'grey'" class="mr-1">{{ s.icona }}</v-icon
							>{{ s.label }}
						</button>
					</div>
				</v-col>
			</v-row>

			<v-expansion-panels v-model="regoleAperte" multiple flat class="bs-panels mt-2">
				<v-expansion-panel v-for="r in regole" :key="r.key" class="bs-panel">
					<v-expansion-panel-header class="bs-panel-head">
						<div class="d-flex align-center">
							<v-icon small color="primary" class="mr-2">{{ r.icona }}</v-icon>
							<span class="bs-panel-title">{{ r.label }}</span>
							<v-chip x-small label :color="pieno(r.key) ? 'success' : undefined" :outlined="!pieno(r.key)" class="ml-2">{{ pieno(r.key) ? 'scritte' : 'vuote' }}</v-chip>
						</div>
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<div class="bs-help">{{ r.aiuto }}</div>
						<v-textarea v-model="blog.setting[r.key]" outlined dense auto-grow rows="3" hide-details />
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>

			<div class="d-flex mt-3">
				<v-spacer></v-spacer>
				<v-btn depressed color="primary" @click="$emit('salva')"><v-icon left small>mdi-content-save-outline</v-icon>Salva impostazioni</v-btn>
			</div>
		</div>
	</SectionCard>
</template>

<script>
import SectionCard from '@/components/core/SectionCard.vue';

// impostazioni del servizio blog (scrittura degli articoli con l'IA); il salvataggio resta nel genitore
export default {
	name: 'BlogSettings',
	components: { SectionCard },
	props: {
		blog: { type: Object, required: true },
		langs: { type: Array, default: () => [] },
		aperto: { type: Boolean, default: false },
	},
	data() {
		return {
			regoleAperte: [],
			social: [
				{ value: 'facebook', label: 'Facebook', icona: 'mdi-facebook' },
				{ value: 'instagram', label: 'Instagram', icona: 'mdi-instagram' },
				{ value: 'tiktok', label: 'TikTok', icona: 'mdi-music-note' },
			],
			regole: [
				{ key: 'preview', label: 'Regole per creare gli articoli', icona: 'mdi-lightbulb-on-outline', aiuto: 'Come scegliere gli argomenti e scrivere l’anteprima: tono, pubblico, cosa evitare.' },
				{ key: 'article', label: "Regole per il testo dell'articolo", icona: 'mdi-text-long', aiuto: 'Come sviluppare l’articolo completo: lunghezza, struttura, link ai prodotti.' },
				{ key: 'image', label: "Regole per l'immagine", icona: 'mdi-image-outline', aiuto: 'Che immagine generare: stile, colori, cosa deve comparire.' },
			],
		};
	},
	methods: {
		condiviso(v) {
			return (this.blog.setting.share || []).includes(v);
		},
		cambiaSocial(v) {
			const s = this.blog.setting.share || [];
			this.$set(this.blog.setting, 'share', s.includes(v) ? s.filter(x => x !== v) : [...s, v]);
		},
		pieno(key) {
			return !!String(this.blog.setting[key] || '').trim();
		},
	},
};
</script>

<style scoped>
.bs-summary {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 6px 18px;
	font-size: 13px;
	color: #1f2d3d;
}
.bs-fact {
	display: flex;
	align-items: center;
}
.bs-body {
	margin-top: 12px;
	padding-top: 12px;
	border-top: 1px solid #eef2f7;
}
.bs-fields {
	margin: 0;
}
.bs-fields > [class*='col'] {
	padding: 6px;
}
.bs-label {
	font-size: 12px;
	color: #5f6b7a;
	margin-bottom: 4px;
}
.bs-socials {
	display: flex;
	gap: 6px;
	flex-wrap: wrap;
}
.bs-social {
	display: inline-flex;
	align-items: center;
	padding: 4px 10px;
	border: 1px solid #e1e7ef;
	border-radius: 999px;
	background: #fff;
	font-size: 13px;
	cursor: pointer;
}
.bs-social--on {
	border-color: #01579b;
	background: #eef4fd;
	color: #01579b;
	font-weight: 600;
}
.bs-panels {
	border: 1px solid #e1e7ef;
	border-radius: 10px;
	overflow: hidden;
}
.bs-panel + .bs-panel {
	border-top: 1px solid #eef2f7;
}
.bs-panel::before {
	box-shadow: none !important;
}
.bs-panel-head {
	min-height: 46px !important;
	padding: 8px 14px;
}
.bs-panel-title {
	font-size: 14px;
	font-weight: 600;
	color: #1f2d3d;
}
.bs-help {
	font-size: 12px;
	color: #5f6b7a;
	margin-bottom: 6px;
}
</style>
